import { render, staticRenderFns } from "./Subtitle.component.vue?vue&type=template&id=c2b69560&scoped=true&"
import script from "./Subtitle.component.vue?vue&type=script&lang=js&"
export * from "./Subtitle.component.vue?vue&type=script&lang=js&"
import style0 from "./Subtitle.component.vue?vue&type=style&index=0&id=c2b69560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b69560",
  null
  
)

export default component.exports